export type DesktopHistoryState = { canGoBack: boolean; canGoForward: boolean };

type NavigationLike = {
  canGoBack?: unknown;
  canGoForward?: unknown;
  addEventListener?(type: string, listener: () => void): void;
  removeEventListener?(type: string, listener: () => void): void;
};

/** Chromium's Navigation API reports both directions; other engines report none. */
export function readDesktopHistoryState(
  navigation: unknown
): DesktopHistoryState {
  if (!navigation || typeof navigation !== 'object')
    return { canGoBack: false, canGoForward: false };
  const value = navigation as NavigationLike;
  return {
    canGoBack: value.canGoBack === true,
    canGoForward: value.canGoForward === true,
  };
}

export function subscribeDesktopHistory(
  navigation: unknown,
  listener: () => void
): () => void {
  const value = navigation as NavigationLike | null;
  if (
    !value ||
    typeof value.addEventListener !== 'function' ||
    typeof value.removeEventListener !== 'function'
  )
    return () => {};
  value.addEventListener('currententrychange', listener);
  return () => value.removeEventListener?.('currententrychange', listener);
}
